import { useDesignMaxTheme } from "@/packages";
import { HEADER_GROUP, useBookingYeogiRecoilValue, useNewNavigate } from "@/shared/client";
import { FONT } from "@/styles";
import { getDefaultParameters } from "@/utils";
import { Box, Center, Flex, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { type DetailMenuBarProps } from "./detailMenuBar.type";

export const DetailMenuBar = ({ navigation }: DetailMenuBarProps) => {
    const [previewImg, setPreviewImg] = useState("");
    const { onNavigate } = useNewNavigate();
    const { COLORS, MEDIAS } = useDesignMaxTheme();
    const bookingYeogi = useBookingYeogiRecoilValue();
    const { isMobile, isLaptop } = MEDIAS();
    const { idx, co_id } = getDefaultParameters();

    const headerBoxPCJustify = isLaptop ? "space-between" : "";
    const hedaerBoxPCFlexDir = isLaptop ? "row" : "column";

    const laptopWidth = isLaptop ? "60%" : "auto";

    const aboutSpecial = HEADER_GROUP.slice(0, 2);
    const Rooms = HEADER_GROUP.filter((header) => header.title === "Rooms");
    const guideReserve = HEADER_GROUP.slice(3, 5);

    useEffect(() => {
        if (navigation) setPreviewImg(navigation.otherList.main);
    }, [navigation]);
    return (
        <Center
            zIndex="3"
            maxW="1744px"
            w="100%"
            h="100%"
            paddingLeft={isLaptop ? "0" : "24px"}
            overflow={isMobile ? "auto" : ""}
            justifyContent="space-between"
            alignItems={isMobile ? "flex-start" : "center"}
        >
            <Flex
                maxW={isLaptop ? "620px" : "auto"}
                w="100%"
                h="100%"
                columnGap={isLaptop ? "" : "88px"}
                justifyContent={isMobile ? "" : headerBoxPCJustify}
            >
                <Flex
                    w={isMobile ? "50%" : laptopWidth}
                    flexDir={isMobile ? "column" : hedaerBoxPCFlexDir}
                    rowGap={isMobile ? "16PX" : "32px"}
                    justifyContent={isMobile ? "" : headerBoxPCJustify}
                    p={isLaptop ? "0" : "0 48px"}
                >
                    <Flex flexDir="column" rowGap={isMobile ? "16PX" : "32px"}>
                        {aboutSpecial.map((header) => (
                            <Flex w="100%" key={header.title} flexDir="column">
                                <Text
                                    as="h4"
                                    sx={{ ...FONT("cormorant", isMobile ? 24 : 32, 700, 1.2) }}
                                    cursor={isMobile ? "pointer" : "default"}
                                >
                                    {header.title}
                                </Text>

                                <Flex
                                    flexWrap="wrap"
                                    flexDir="column"
                                    sx={{
                                        "& > p": {
                                            ...FONT("pretendard", 14, 500),
                                            cursor: "pointer",
                                            color: COLORS.gray[500],
                                            "&:hover": { textDecoration: "underline" },
                                        },
                                    }}
                                >
                                    {header.title === "Specials" ? (
                                        navigation?.specialList &&
                                        navigation.specialList.map((special) => (
                                            <Text
                                                onClick={() => onNavigate({ path: `/specials/${special.specialIdx}` })}
                                                key={special.specialIdx}
                                                p="4px 0"
                                                onMouseEnter={() => setPreviewImg(special.imgUrl)}
                                                onMouseLeave={() => setPreviewImg(navigation.otherList.main)}
                                            >
                                                {special.specialName}
                                            </Text>
                                        ))
                                    ) : (
                                        <>
                                            {header.contents.map((content) => (
                                                <Text
                                                    key={content.title}
                                                    onClick={() => onNavigate({ path: content.path })}
                                                    onMouseEnter={() =>
                                                        navigation && setPreviewImg(navigation?.otherList.about)
                                                    }
                                                >
                                                    {content.title}
                                                </Text>
                                            ))}
                                        </>
                                    )}
                                </Flex>
                            </Flex>
                        ))}
                    </Flex>
                    <Flex flexDir="column" rowGap={isMobile ? "16PX" : "32px"}>
                        {guideReserve.map((header) => (
                            <Flex w="100%" key={header.title} flexDir="column">
                                <Text
                                    as="h4"
                                    sx={{ ...FONT("cormorant", isMobile ? 24 : 32, 700, 1.2) }}
                                    cursor={isMobile ? "pointer" : "default"}
                                >
                                    {header.title}
                                </Text>
                                <Flex
                                    flexWrap="wrap"
                                    flexDir="column"
                                    sx={{
                                        "& > p": {
                                            ...FONT("pretendard", 14, 500),
                                            cursor: "pointer",
                                            color: COLORS.gray[500],
                                            "&:hover": { textDecoration: "underline" },
                                        },
                                    }}
                                >
                                    {header.contents.map((content) => {
                                        const isCheck = content.title === "예약조회";
                                        const isBookingHerb = content.title === "부킹허브";
                                        if (isBookingHerb) {
                                            if (bookingYeogi) {
                                                console.log(bookingYeogi);
                                                return (
                                                    <Text
                                                        key={content.title}
                                                        onClick={() => window.open(bookingYeogi, "_blank")}
                                                    >
                                                        {content.title}
                                                    </Text>
                                                );
                                            }
                                            if (!bookingYeogi) return null;
                                        }
                                        return (
                                            <Text
                                                onClick={() =>
                                                    isCheck
                                                        ? window.open(
                                                              `https://marginauto.kr/api/testCalendar/public/check.html?idx=${idx}&co_id=${co_id}`,
                                                              "_blank",
                                                          )
                                                        : onNavigate({ path: content.path })
                                                }
                                                key={content.title}
                                                p="4px 0"
                                                onMouseEnter={() =>
                                                    navigation && setPreviewImg(navigation?.otherList.exterior)
                                                }
                                            >
                                                {content.title}
                                            </Text>
                                        );
                                    })}
                                </Flex>
                            </Flex>
                        ))}
                    </Flex>
                </Flex>
                <Flex w={isMobile ? "50%" : "auto"} justifyContent="flex-end" overflow="auto">
                    {Rooms.map((room) => (
                        <Flex w="100%" key={room.title} flexDir="column">
                            <Text
                                as="h4"
                                sx={{ ...FONT("cormorant", isMobile ? 24 : 32, 700, 1.2) }}
                                cursor={isMobile ? "pointer" : "default"}
                            >
                                {room.title}
                            </Text>
                            <Flex
                                flexDir="column"
                                sx={{
                                    "& > p": {
                                        ...FONT("pretendard", 14, 500),
                                        cursor: "pointer",
                                        color: COLORS.gray[500],
                                        "&:hover": { textDecoration: "underline" },
                                    },
                                }}
                            >
                                {navigation?.roomList &&
                                    navigation.roomList.map((room) => (
                                        <Text
                                            onClick={() => onNavigate({ path: `/rooms/${room.roomIdx}` })}
                                            key={room.roomIdx}
                                            p="4px 0"
                                            onMouseEnter={() => setPreviewImg(room.imgUrl)}
                                            onMouseLeave={() => setPreviewImg(navigation.otherList.main)}
                                        >
                                            {room.roomName}
                                        </Text>
                                    ))}
                            </Flex>
                        </Flex>
                    ))}
                </Flex>
            </Flex>
            <Flex display={isLaptop ? "none" : "flex"} maxW="840px" w="100%" h="100%" alignItems="flex-end">
                <Box
                    w="100%"
                    h="578px"
                    background={`url(${previewImg})no-repeat center/cover`}
                    borderRadius="16px"
                    transition="opacity 0.5s"
                    opacity={previewImg === "transparent" ? 0 : 1}
                ></Box>
            </Flex>
        </Center>
    );
};
